export const TOGGLE_FAVORITE_VOICE = 'TOGGLE_FAVORITE_VOICE'